import { httpClient } from '@/lib/httpClient';

export interface AuditLog {
  id: number;
  userId: number;
  customerId: number;
  action: string;
  description: string;
  changes?: {
    after: string | null;
    before: string | null;
  };
  createdAt: string;
}

export interface AuditLogsResponse {
  totalItems: number;
  currentPage: number;
  totalPages: number;
  items: AuditLog[];
}

export interface AuditLogQueryFilterDto {
  page: number;
  limit: number;
  customer?: number;
  action?: string;
}

class AuditLogsService {
  constructor() {}

  async getAuditLogs(auditLogQueryFilterDto: AuditLogQueryFilterDto) {
    const { page, limit, customer, action } = auditLogQueryFilterDto;

    const { data } = await httpClient.get<AuditLogsResponse>('/v1/audit-logs', {
      params: {
        page,
        limit,
        customer,
        action,
      },
    });
    return data;
  }

  async getAuditActions() {
    const { data } = await httpClient.get<string[]>('/v1/audit-logs/actions');
    return data;
  }
}
export default new AuditLogsService();
